import { Component } from '@angular/core';
import { Login, Result, user_autentica, users } from 'src/app/models/Login';
import { QrService } from 'src/app/service/qr.service';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/service/storage.service';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { LoadingService } from 'src/app/loading/loading.service';

@Component({
  selector: 'app-ingresar',
  templateUrl: './ingresar.component.html',
  styleUrls: ['./ingresar.component.css']
})
export class IngresarComponent {
  usuario: string = '';
  password: string = '';
  private loginUser: Login | undefined;
  private userResult: users | undefined;
  private userResult2: user_autentica | undefined;
  recordarme: boolean = false;

  private promiseresponse: Result | null = null;

  //gif
  loading$ = this.loadingService.loading$;


  constructor(private modulesService: QrService,
    private route: Router,
    private storageService: StorageService,
    private toastr: ToastrService,
    private loadingService: LoadingService
  ) {
  }

  ngOnInit(): void {
    this.userResult2 = this.storageService.getUsuarioRecordarStorage();

    // Por seguridad solo se recuerda el correo, nunca la contraseña
    // (ver StorageService.setUsuarioRecordarStorage). El usuario debe
    // volver a escribir su contraseña aunque tenga "recordarme" activo.
    if (this.userResult2?.email != null) {
      this.usuario = this.userResult2.email;
      this.recordarme = true;
    }
  }




  ingresar() {
    if (this.usuario == null || this.usuario.trim() == "" || this.usuario == undefined) {
      this.toastr.info('Debe ingresar el usuario', 'ALERTA');
    }
    else if (this.password == null || this.password.trim() == "" || this.password == undefined) {
      this.toastr.info('Debe ingresar la contraseña', 'ALERTA');
    }
    else {
      this.loadingService.show();
      // La API externa de login ya no está disponible: se autentica
      // directamente contra la BD del backend propio (Users/Loguin_User).
      this.ingresarxCuentaBD();
    }



  }

  ingresarxCuentaBD() {

    try {
      this.loginUser = new Login();
      this.loginUser.email = this.usuario; //"julio.aojalla@claro.com.pe";
      this.loginUser.password = this.password;//"P@ssW0rd123456";

//      console.log('funcion ingresar:' + JSON.stringify(this.loginUser));

      this.modulesService.Loguin_User(this.loginUser).subscribe(
        async (message2: any) => {
          this.userResult = new users;
          this.userResult2 = new user_autentica;
          if (message2) {
            this.userResult.idUser = message2.idUser;
            this.userResult.nombre = message2.nombres;
            this.userResult.apellidos = message2.apellidos;
            this.userResult.email = message2.email;
            this.userResult.rol = message2.rol;


            if (this.userResult) {
              this.storageService.setUsuarioStorage(this.userResult);
              if (this.recordarme) {
                this.storageService.removeUsuarioStorage_Recordar();
                this.userResult2 = new user_autentica;
                this.userResult2.email = this.usuario;

                this.storageService.setUsuarioRecordarStorage(this.userResult2);
              }else{
                this.storageService.removeUsuarioStorage_Recordar();
              }
              this.loadingService.hide();

              this.route.navigate(['/principal/menu']);
            }
          }else{
            this.loadingService.hide();

            this.toastr.error('Usuario o Contraseña Incorrecto', 'Error');
          }

        },
        error => {
          this.loadingService.hide();

          this.toastr.error('Usuario o Contraseña Incorrecto', 'Error');

        }
      )
    } catch (error) {
      this.loadingService.hide();
      //            console.error('Error al procesar la respuesta del servidor:', error);
      this.toastr.error('Error al procesar la respuesta del servidor', 'Error');
    }
  }

}
